import {InjectionToken} from '@angular/core';

export const NAV_BAR_MENU_ITEM_TOKEN = new InjectionToken('NAVBAR_MENU_ITEM');

export interface NavbarMenuItem {
  title: string,
  link: string,
  image: string
}
